export default __webpack_public_path__ + "static/media/Rojas.ff4ab231.jpg";